import { TaskNoteStatus } from './TaskNote.ts'

type BasePost = {
    id: number
    message: string
    creationDate: Date
    updateDate: Date
    categories?: PostCategory[]
    postedBy?: string
    childIds?: number[]
    views?: View[]
    reactions?: Reaction[]
    visibleAll?: boolean
}

type RegularPost = BasePost & {
    type: PostType.post
    medias: MediaFile[]
    poll?: Poll
}

type TaskNotePost = BasePost & {
    type: PostType.note
    taskNoteTitle: string
    taskNoteStatus?: TaskNoteStatus
    taskNoteDate?: string
    medias: MediaFile[]
}

type CallPost = BasePost & {
    type: PostType.call
    taskNoteTitle: string
    taskNoteStatus: TaskNoteStatus
    taskNoteDate?: string
    medias: MediaFile[]
}

export type Post = RegularPost | TaskNotePost | CallPost

export enum PostType {
    note = 'note',
    call = 'call',
    post = 'post'
}

export enum PollType {
    text_free = 'text_free',
    single_choice = 'single_choice',
    multiple_choice = 'multiple_choice',
    rating = 'rating'
}

export enum RatingDisplay {
    stars = 'stars',
    numbers = 'numbers',
    smileys = 'smileys'
}

export type PollOption = {
    id: number
    text: string
    order: number
}

export type PollOptionResult = {
    id: number
    text: string
    order: number
    count: number
}

export type PollAnswer = {
    textAnswer?: string
    rating?: number
    selectedOptionIds?: number[]
}

export type ParentAnswer = {
    parentName: string
    optionIds?: number[]
    rating?: number
    textAnswer?: string
}

export type PollResults = {
    totalAnswers: number
    averageRating?: number
    options: PollOptionResult[]
    textAnswers?: string[]
    parentAnswers?: ParentAnswer[]
}

export type Poll = {
    id: number
    type: PollType
    deadline?: Date
    ratingDisplay?: RatingDisplay
    options: PollOption[]
    myAnswer?: PollAnswer
    results?: PollResults
    hasVotes: boolean
    anonymous: boolean
}

export type PollOptionInput = {
    text: string
    order: number
}

export type PollInput = {
    type: PollType
    options?: PollOptionInput[]
    deadline?: string
    ratingDisplay?: RatingDisplay
    anonymous?: boolean
}
export type MediaFile = {
    media: Media
    base64Data: string
}

export type PostList = {
    posts: Post[]
    hasMorePosts: boolean
    countDraftPosts: number
}

export enum ReactionType {
    LIKE = 'like',
    LOVE = 'love'
}

export type Reaction = {
    id: number
    reactionType: ReactionType
    parentName: string
}

export enum MediaType {
    IMAGE = 'image',
    VIDEO = 'video',
    PDF = 'pdf'
}

type Media = {
    id: number
    type: MediaType
    fileName: string
    creationDate: Date
    canDownload: boolean
}

export type CreateMediaResponse = {
    id: number
    mediaType: MediaType
}

export type View = {
    parentName: string
    creationDate: Date
}

export type PostCategory = {
    id: number
    name: string
}
